import React from 'react';
export function StarRating({
  rating
}: {
  rating: number;
}) {
  return <div className="flex gap-1" data-id="element-91">
      {[...Array(5)].map((_, i) => <svg key={i} className={`w-4 h-4 ${i < rating ? 'text-primary' : 'text-gray-300'}`} viewBox="0 0 20 20" fill="currentColor" data-id="element-92">
          <path fillRule="evenodd" d="M10 2l2.598 5.263 5.814.847-4.206 4.098.992 5.792L10 15.345 4.802 18l.992-5.792L1.588 8.11l5.814-.847L10 2z" clipRule="evenodd" data-id="element-93" />
        </svg>)}
    </div>;
}